import { render, staticRenderFns } from "./newsSecondPage.vue?vue&type=template&id=ac1934b8&scoped=true&"
import script from "./newsSecondPage.vue?vue&type=script&lang=js&"
export * from "./newsSecondPage.vue?vue&type=script&lang=js&"
import style0 from "./newsSecondPage.vue?vue&type=style&index=0&id=ac1934b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac1934b8",
  null
  
)

export default component.exports